<template>
  <v-navigation-drawer
    height="87vh"
    class="border-bottom"
    style="top: 76px"
    width="500px"
    :stateless="
      cartDialogs.idRequired ||
      minimumOrderAmountDialog ||
      productDialog.addFromCart ||
      productDialog.details ||
      productDialog.modifiers
    "
    :touchless="$vuetify.breakpoint.xsOnly"
    :value="cartDialogs.drawer"
    fixed
    right
    temporary
    @input="handleOutsideClick"
  >
    <CloseDialogButton :close="() => $store.commit('cart/TOGGLE')" />
    <div class="text-center font-size-lg font-weight-semibold mt-10">
      My Cart
    </div>
    <Cart />
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import Cart from "@/components/Cart/Cart.vue";
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";

export default {
  name: "CartDrawer",
  components: { Cart, CloseDialogButton },
  computed: {
    ...mapState({
      cartDialogs: (state) => state.cart.dialogs,
      minimumOrderAmountDialog: (state) =>
        state.orders.dialog.minimumOrderAmount,
      productDialog: (state) => state.product.dialog,
    }),
  },
  methods: {
    handleOutsideClick(input) {
      !input && this.$store.commit("cart/SET", false);
    },
  },
};
</script>
